<section class="pt-2">
  <div class="container-style">
    <div class="row align-items-center pb-2">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6> {{ isFormView ? 'Registrar detalle de programación mtto.' : 'Detalle de programación mtto.' }} </h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
        <div class="d-flex gap-2">
          <app-custom-button [label]="'Generar Ord. Mtto.'" [severity]="'success'" [disabled]="disabledDetail"
            [icon]="'pi pi-file-plus'" [width]="'9.5rem'" (onClick)="generateMaintenanceOrders()"></app-custom-button>
          <app-custom-modal #generateMaintenanceOrderModal [label]="'Generar'"
            [header]="'Generar órdenes de mantenimiento'" [children]="componentGenerateMaintenanceOrders"
            [inputs$]="inputsForGenerateMaintenanceOrders$" [output$]="output$" [width]="'70vw'" hidden>
          </app-custom-modal>

          <app-custom-button [label]="'Procesar Prog.'" [severity]="'primary'" [disabled]="disabledDetail"
            [icon]="'pi pi-sync'" [width]="'9.5rem'" (onClick)="processMaintenanceScheduling()"></app-custom-button>
          <app-custom-modal #processMaintenanceSchedulingModal [label]="'Procesar'"
            [header]="'Procesar programación de mantenimiento'" [children]="componentProcessMaintenanceScheduling"
            [inputs$]="inputsForProcessMaintenanceScheduling$" [output$]="output$" [width]="'70vw'" hidden>
          </app-custom-modal>
        </div>
      </div>
    </div>
    <div class="row mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">

      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]="!disabledDetail" [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getDetailsForCapture()"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>